var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search-field"
  }, [_c('transition', {
    attrs: {
      "name": "from-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    staticClass: "search-wrapper",
    class: {
      'collapsed': !_vm.isOpen
    }
  }, [_c('label', {
    staticClass: "search-label",
    attrs: {
      "for": "search"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.searchText,
      expression: "searchText",
      modifiers: {
        "trim": true
      }
    }],
    ref: "searchText",
    staticClass: "search-input",
    attrs: {
      "id": "search",
      "type": "text",
      "title": _vm.$t('search.by.transactions'),
      "placeholder": _vm.$t('common.search'),
      "maxlength": "64",
      "spellcheck": "false",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.searchText
    },
    on: {
      "focus": function focus($event) {
        return _vm.$emit('toggle-block');
      },
      "blur": [function ($event) {
        return _vm.$emit('toggle-block');
      }, function ($event) {
        return _vm.$forceUpdate();
      }],
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value.trim();
      }
    }
  })])]), _c('button', {
    staticClass: "search-button",
    class: {
      'collapsed': _vm.isOpen
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.toggleSearch($event);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }